module.exports = __webpack_public_path__ + "static/media/shell.02213411.png";